import { ContentBlockDto } from '../../shared/api';

export function getCover(
  content: ContentBlockDto[],
): ContentBlockDto | undefined {
  return content.find((block) => !!block.tunes?.['cover']);
}
